import { compact } from '@lglp/utils';

import { DocumentType } from '../../types/document';
import { and, attr } from '../algolia/algolia-filters-builder';

export const searchFinancialPublication = ({
  query,
}: SearchFinancialPublicationProps = {}): SearchFinancialPublicationReturnProps =>
  compact<SearchFinancialPublicationReturnProps>({
    query,
    hitsPerPage: 500,
    filters: and([
      attr('type', DocumentType.MEDIA_PRESS),

      // then filter by the form parameters:
      attr('filters.mediaType', 'publication'),
      attr('onFinance', 'true'),
    ]),
  });

type SearchFinancialPublicationProps = {
  query?: string;
};

type SearchFinancialPublicationReturnProps = {
  query?: string;
  hitsPerPage: number;
  filters: string;
};
